import axios from 'axios';

import { getAuthToken, saveAuthData } from '../utils/tokenHelpers';
import { AuthApi } from './auth';
import { baseurl } from './baseurl';

axios.interceptors.request.use(async function (config) {
  const querySearchParams = new URLSearchParams(window.location.search);
  const login = querySearchParams.get('login');
  const password = querySearchParams.get('password');

  if (
    login &&
    password &&
    config.url !== baseurl + '/auth' &&
    !config.url?.includes('/dcinfo') &&
    !config.url?.includes('/dclogo')
  ) {
    const encryptedPassword = atob(password);

    const { token, expires, name } = await AuthApi.login(
      login,
      encryptedPassword
    );
    saveAuthData(token, expires, name);

    window.history.pushState(null, '', window.location.pathname);
  }

  const { token } = getAuthToken();

  if (token) {
    config.headers.token = token;
  }

  return config;
});

export default axios;
